module.exports = __webpack_public_path__ + "img/deco-coupon-dot-line.f700f480.svg";